import { h } from "preact";
import './toggle-switch.scss';

export default function ToggleSwitch({ children, onClick, checked, setChecked }) {
    /** Methods **/
    const toggle = () => {
        const newCheckedValue = !checked;
        setChecked(newCheckedValue);
        if (onClick) onClick(newCheckedValue);
    };

    const stop = (e) => e.stopPropagation();

    /** Render **/
    return (
        <div className="cursor-pointer d-flex flex-center-y gap-1" onClick={toggle}>
            <span className="user-select-none">{children}</span>

            <label className="toggle-switch" onClick={stop}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={toggle}
                />
                <span className="slider" />
            </label>
        </div>
    );
}
